import React, { useState, useRef, useEffect } from 'react';
import dappBg from './assets/dapp/dappBg.svg';
import { redirect, logAnalytics } from './util';
import { useNavigate } from 'react-router-dom';
import { RedirectURLs } from './constants/redirectURLS';
import AllProductsComponent from './components/allProductsComponent';
import { AppImages } from './assets/s3';
import { Player } from '@lottiefiles/react-lottie-player';
import swap from './assets/lottie/swap.json';
import defiInvestments from './assets/lottie/defiInvestments.json';
import stake from './assets/lottie/stake.json';
import defi from './assets/lottie/defi.json';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { get } from 'lodash';
import { chainLogoMapping } from './constants/data.js';
import trackWallet from './assets/lottie/trackWallet.json';
import { CiSearch } from 'react-icons/ci';
import SeoComponent from './components/seoComponent.jsx';

export default function DappLanding() {
  const navigate = useNavigate();
  const [trackWalletAddress, setTrackWalletAddress] = useState('');
  const animatedDivRefs = useRef({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleMouseEnter = (id) => {
    animatedDivRefs.current[id]?.play();
  };

  const handleMouseLeave = (id) => {
    animatedDivRefs.current[id]?.stop();
  };

  const [showMoreExpanded, setShowMoreExpanded] = useState(false);

  const chainsSupported = {
    Ethereum: [true, true, false],
    Polygon: [true, true, false],
    Cosmos: [true, false, true],
    Osmosis: [true, false, true],
    BSC: [true, true, false],
    Optimism: [true, true, false],
    Arbitrum: [true, true, false],
    Base: [true, true, false],
    Noble: [true, false, false],
    Fantom: [true, false, false],
    Avalanche: [true, true, false],
    Juno: [true, false, true],
    Aurora: [true, false, false],
    Coreum: [true, false, false],
    Moonbeam: [true, false, false],
    Moonriver: [true, false, false],
    Stargaze: [true, false, true],
    Evmos: [true, false, true],
  };

  return (
    <>
      <SeoComponent page={window.location.pathname} />
      <div className='bg-white'>
        <div class='flex flex-col items-center justify-center w-full'>
          <div
            class={'bg-cover bg-center h-full w-full relative'}
            style={{ backgroundImage: `url("${dappBg}")` }}
          >
            <div className='flex flex-col md:flex-row justify-center items-center mt-[136px] md:mt-[315px] mb-8 md:mb-[400px] px-8'>
              <div className='flex flex-col w-full max-w-[448px] items-start lg:mr-[141px]'>
                <p className='lg:text-[64px] md:text-[36px] text-[28px] font-bold tracking-tighter'>
                  Explore All Of Web3 <br />{' '}
                  <span className='text-[#FFB900]'>At Cypher dApp</span>
                </p>
                <p className='lg:text-[36px] md:text-[26px] text-[14px] tracking-tight mt-3'>
                  Buy, stake, sell with Crypto card
                </p>
              </div>

              <div className='flex flex-col'>
                <div className='flex flex-col w-full max-w-[448px] h-[220px] mt-8 md:mt-0 rounded-[16px] p-6 bg-white shadow-[4px_4px_34px_0px_rgba(0,0,0,0.12)]'>
                  <p className='font-semibold text-[23px] text-center'>
                    Let's Get Started
                  </p>
                  <button
                    className='w-full font-semibold rounded-[8px] bg-[#FFB900] mt-6 py-[13px]'
                    onClick={() => {
                      redirect(RedirectURLs.dAppConnectWallet);
                      logAnalytics({
                        category: 'dapp',
                        action: 'connect wallet',
                        label: 'launch dapp',
                      });
                    }}
                  >
                    Launch dApp
                  </button>
                  <p className='text-xs text-[#98A1B0] mt-4 tracking-tight'>
                    Unleash the power of DeFi - connect your wallet for a
                    seamless web3 experience.
                  </p>
                </div>

                <div className='flex flex-col w-full max-w-[448px] h-[220px] mt-8 rounded-[16px] p-6 bg-white shadow-[4px_4px_34px_0px_rgba(0,0,0,0.12)]'>
                  <p className='text-center font-semibold text-[23px]'>
                    Track Wallet
                  </p>
                  <p className='font-semibold text-xs text-[#6B778C] mt-6'>
                    Track Wallet
                  </p>
                  <div className='px-2 py-3 flex flex-row rounded-[8px] justify-between items-center border border-[#C2C7D0] mt-[6px]'>
                    <input
                      className='bg-n20 py-0 -my-4 text-primaryText text-sm h-6 w-full border-none outline-none'
                      placeholder='Track any EVM or Cosmos Address or EVS Name'
                      value={trackWalletAddress}
                      onChange={(e) => {
                        setTrackWalletAddress(e.target.value);
                      }}
                      type={'text'}
                      id={'trackWallet'}
                      name={'trackWallet'}
                      onPaste={(e) => {
                        redirect(
                          RedirectURLs.dAppTrackWallet +
                            e.clipboardData.getData('text/plain')
                        );
                        logAnalytics({
                          category: 'dapp',
                          action: 'track wallet',
                          label: 'by pasting address',
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && trackWalletAddress) {
                          redirect(
                            RedirectURLs.dAppTrackWallet + trackWalletAddress
                          );
                          e.preventDefault();
                          logAnalytics({
                            category: 'dapp',
                            action: 'track wallet',
                            label: 'by pressing enter',
                          });
                        }
                      }}
                    />
                    <CiSearch
                      className={`h-6 w-6 ${
                        trackWalletAddress
                          ? 'cursor-pointer'
                          : 'cursor-not-allowed'
                      }`}
                      onClick={() => {
                        if (trackWalletAddress) {
                          redirect(
                            RedirectURLs.dAppTrackWallet + trackWalletAddress
                          );
                          logAnalytics({
                            category: 'dapp',
                            action: 'track wallet',
                            label: 'by pressing search button',
                          });
                        }
                      }}
                    />
                  </div>
                  <p className='text-xs text-[#98A1B0] mt-4 tracking-tight'>
                    Effortlessly track any EVM, Cosmos wallets, and ENS names in
                    one place
                  </p>
                </div>
              </div>
            </div>
          </div>

          <AllProductsComponent />

          <div className='flex flex-col bg-[#E9F4FF] py-[45px] px-4 items-center rounded-[32px] w-full max-w-[1156px] mt-[50px] md:mt-[100px]'>
            <p className='text-[28px] font-bold text-black'>
              One Platform, Do All Of Web3
            </p>
            <p className='text-[16px] text-[#666666] mt-3'>
              Load your card with over 500+ supported tokens across 18+ EVM &
              Cosmos chains.
            </p>
            <div className='bg-white rounded-[16px] p-6 w-full max-w-[780px] mt-[30px] flex flex-col items-center'>
              <div>
                <table className='table-auto'>
                  <thead>
                    <tr>
                      <th>
                        <div className='mx-2 md:mr-[133px] font-bold'>
                          Chains
                        </div>
                      </th>
                      <th>
                        <div className='mx-2 md:mx-[55px] font-bold'>
                          Card Load
                        </div>
                      </th>
                      <th>
                        <div className='mx-2 md:mx-[55px] font-bold'>Swap</div>
                      </th>
                      <th>
                        <div className='mx-2 md:mx-[55px] font-bold'>Stake</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {(showMoreExpanded
                      ? Object.keys(chainsSupported)
                      : Object.keys(chainsSupported).slice(0, 4)
                    ).map((chain) => {
                      return (
                        <tr>
                          <td>
                            <div className='mt-6 flex flex-row items-center'>
                              <img
                                src={get(chainLogoMapping, chain)}
                                className='h-8 w-8 mr-2'
                              />
                              <p className='font-bold'>{chain}</p>
                            </div>
                          </td>
                          {chainsSupported[chain].map((value) => {
                            return (
                              <td>
                                <div className='w-full flex flex-col items-center mt-6'>
                                  <img
                                    src={
                                      value
                                        ? AppImages.YELLOW_CHECK_MARK
                                        : AppImages.WRONG_CIRCLE
                                    }
                                  />
                                </div>
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className='flex flex-col items-center w-full mt-6'>
                <div
                  className='flex flex-row items-center cursor-pointer'
                  onClick={() => {
                    setShowMoreExpanded(!showMoreExpanded);
                    logAnalytics({
                      category: 'dapp',
                      action: 'click show more chains',
                      label: 'see all supported chains',
                    });
                  }}
                >
                  <p className='text-black mr-2 font-bold'>Show More Chains</p>
                  {showMoreExpanded ? (
                    <IoIosArrowUp className={'min-h-4 min-w-4'} />
                  ) : (
                    <IoIosArrowDown className={'min-h-4 min-w-4'} />
                  )}
                </div>
              </div>
            </div>
            <div className=''></div>
          </div>

          <div className='flex flex-col items-center mt-[84px] md:mt-[120px]'>
            <p className='text-[24px] lg:text-[44px] font-bold tracking-tighter text-center'>
              True <span className='text-[#FFB900]'>Crypto Ownership.</span>
              <br /> Powerful Web3 experiences on{' '}
              <span className='text-[#FFB900]'>Browser</span>
            </p>
          </div>

          <div className='flex flex-col lg:flex-row w-full max-w-[1156px] items-center justify-center mt-[84px] lg:mt-[120px] md:px-4'>
            <div className='flex flex-col mx-4 lg:ml-0 lg:mr-6 '>
              <div className='flex flex-col rounded-[16px] bg-[#1F1F1F] p-6 pb-8 overflow-hidden max-w-[448px] max-h-[362px]'>
                <img
                  src={AppImages.CRYPTO_CARDS_BUNCH}
                  className='w-[192px] h-[219px] -mt-[110px] ml-[90px] lg:h-[308px] lg:w-[272px]'
                />
                <p className='font-bold text-[#ffffff] text-[16px] md:text-[20px] tracking-tight'>
                  Spend your crypto anytime, anywhere with <br /> Cypher Card
                </p>
                <div className='text-[12px] text-[#999999] mt-3'>
                  Load card to pay with crypto in a million stores around the
                  world, both online and offline
                </div>
              </div>
              <div
                className='flex flex-col rounded-[16px] bg-[#F2F3F6] mt-6 overflow-hidden border border-[#D1D1D1] max-h-[499px] max-w-[448px]'
                id='animatedDiv1'
                onMouseEnter={() => handleMouseEnter('animatedDiv1')}
                onMouseLeave={() => handleMouseLeave('animatedDiv1')}
              >
                <div
                  className='bg-cover bg-center h-full w-full relative'
                  style={{ backgroundImage: `url("${AppImages.SWAP_BG}")` }}
                >
                  <div className=''>
                    <Player
                      ref={(ref) =>
                        (animatedDivRefs.current['animatedDiv1'] = ref)
                      }
                      loop={true}
                      src={swap}
                      className={'max-h-[400px] max-w-[380px]'}
                      autoPlay={false}
                      keepLastFrame={true}
                    />
                  </div>
                  <p className='font-bold text-[#000000] text-[16px] md:text-[20px] tracking-tight px-6 mt-6'>
                    Swap across 9+ EVM Chain
                  </p>
                  <div className='text-xs text-[#999999] mt-3 mb-[32px] px-6'>
                    Support 200+ Tokens across 9+ chains
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col mx-4 lg:mx-0'>
              <div
                className='flex md:flex-row flex-col rounded-[16px] bg-[#1F1F1F] mt-6 overflow-hidden max-w-[448px] lg:max-w-[684px] lg:max-h-[280px]'
                id='animatedDiv3'
                onMouseEnter={() => handleMouseEnter('animatedDiv3')}
                onMouseLeave={() => handleMouseLeave('animatedDiv3')}
              >
                <div
                  className='flex flex-col justify-end mt-6 lg
                :mt-0 md:mb-6 ml-6'
                >
                  <p className='font-bold text-[16px] md:text-[20px] text-[#ffffff] tracking-tight'>
                    Track any EVM or Cosmos <br /> Address or ENS Name
                  </p>
                  <div className='text-[12px] text-[#999999] mt-3'>
                    View all your DeFi assets that you’ve staked in one place
                  </div>
                </div>
                <div className='md:mr-[59px]'>
                  <Player
                    ref={(ref) =>
                      (animatedDivRefs.current['animatedDiv3'] = ref)
                    }
                    loop={true}
                    src={trackWallet}
                    className={'max-h-[316px] max-w-[316px]'}
                    autoPlay={false}
                    keepLastFrame={true}
                  />
                </div>
              </div>
              <div
                className='flex flex-col rounded-[16px] bg-[#F2F3F6] max-w-[448px] lg:max-w-[684px] lg:max-h-[584px] mt-6 lg:mt-0 lg:-order-1 border border-[#D1D1D1] lg:border-0'
                id='animatedDiv2'
                onMouseEnter={() => handleMouseEnter('animatedDiv2')}
                onMouseLeave={() => handleMouseLeave('animatedDiv2')}
              >
                <div
                  class={'bg-cover bg-center h-full w-full relative'}
                  style={{ backgroundImage: `url("${dappBg}")` }}
                >
                  <div className='mt-[10px]'>
                    <Player
                      ref={(ref) =>
                        (animatedDivRefs.current['animatedDiv2'] = ref)
                      }
                      loop={true}
                      src={stake}
                      className={'max-h-[444px] max-w-[525px]'}
                      autoPlay={false}
                      keepLastFrame={true}
                    />
                  </div>
                  <p className='font-bold text-[16px] md:text-[20px] text-[#000000] tracking-tight mt-[43px] mx-6'>
                    Stake Crypto Instantly
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3 mx-6 mb-6'>
                    Stake your favorite cryptocurrencies and manage your assets
                    effortlessly
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='flex flex-col items-center mt-[54px] md:mt-[100px]'>
            <p className='text-[24px] lg:text-[44px] font-bold tracking-tighter text-center'>
              Track Your <span className='text-[#FFB900]'>DeFi Investment</span>
              <br /> Across 4485+ Protocols{' '}
            </p>
          </div>

          <div className='flex flex-col items-center w-full px-4'>
            <div
              className='flex flex-col md:flex-row bg-[#1F1F1F] w-full max-w-[1156px] max-h-[475px] rounded-[12px] mt-[54px] md:mt-[100px] overflow-hidden'
              id='animatedDiv4'
              onMouseEnter={() => handleMouseEnter('animatedDiv4')}
              onMouseLeave={() => handleMouseLeave('animatedDiv4')}
            >
              <div className='flex flex-col justify-end px-8 md:pr-0 py-8 max-w-full md:max-w-[468px]'>
                <p className='text-[30px] text-white font-semibold tracking-tight'>
                  Track all your DeFi investments <br /> in one place
                </p>
                <p className='text-xs text-[#E9E9E9]'>
                  Manage your DeFi portfolio seamlessly with our platform,
                  tracking all investments, yielding insights, and optimizing
                  your strategies effortlessly.
                </p>
              </div>
              <div className='mr-8'>
                <Player
                  ref={(ref) => (animatedDivRefs.current['animatedDiv4'] = ref)}
                  loop={true}
                  src={defiInvestments}
                  className={
                    'max-h-[252px] max-w-[350px] md:max-h-[473px] md:max-w-[656px] '
                  }
                  autoPlay={false}
                  keepLastFrame={true}
                />
              </div>
            </div>

            <div
              className='flex flex-col md:flex-row bg-[#E9F4FF] w-full max-w-[1156px] max-h-[475px] rounded-[12px] mt-6 overflow-hidden pb-8 md:pb-0'
              id='animatedDiv5'
              onMouseEnter={() => handleMouseEnter('animatedDiv5')}
              onMouseLeave={() => handleMouseLeave('animatedDiv5')}
            >
              <div className='flex flex-col justify-end px-8 md:pr-0 py-8 max-w-[524px]'>
                <p className='text-[30px] text-black font-semibold tracking-tight'>
                  Your go-to source for all <br /> updates, trends, and
                  insights.
                </p>
                <p className='text-xs text-[#666666]'>
                  Stay ahead of DeFi trends with Cypher: Your ultimate source
                  for updates, insights, and all things decentralized finance.
                </p>
              </div>
              <div className='md:my-[14px] md:mr-[50px]'>
                <Player
                  ref={(ref) => (animatedDivRefs.current['animatedDiv5'] = ref)}
                  loop={true}
                  src={defi}
                  className={
                    'max-h-[284px] max-w-[342px] md:max-h-[446px] md:max-w-[539px]'
                  }
                  autoPlay={false}
                  keepLastFrame={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
